<template>
    <AppLayout>
        <PageHero title="About Us" description="Get to know our mission, our tutors, and the story behind Global Arabic."
            image="/images/courses/quran.jpg" />

        <Container>
            <div class="cms-content mx-auto max-w-3xl py-16" v-html="aboutUs ? aboutUs.content : '...'"></div>
        </Container>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import Container from '@/components/ui/Container.vue';
import PageHero from '@/components/ui/PageHero.vue';
import { ref } from 'vue';
import { getAboutUs } from '@/services/pageService';

const aboutUs = ref(null);

const fetchAboutUs = async () => {
    const response = await getAboutUs();
    aboutUs.value = response.data;
}

fetchAboutUs();
</script>
